export function Indisponivel() {
  return "--";
}
